export const SET_GRID_DATA = "SET_GRID_DATA";

export const setGridData = (data) => ({
  type: SET_GRID_DATA,
  payload: data,
});
